import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Required'),
  permissions: Yup.array().of(Yup.object().shape({
    subject: Yup.string(),
    action: Yup.string()
  }))
})
